// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProviderSelectionForm-providerSectionCardWrapper-HHOCp {
    display: grid;
    gap: 18px;
}

.ProviderSelectionForm-providerSectionCard-nXB1G {
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    padding: 18px;
    cursor: pointer;
}

.ProviderSelectionForm-cardHeaderContainer-PU09N {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--primary-border);
    margin-bottom: 12px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.ProviderSelectionForm-cardHeaderInnerFlexWrapper-FeDD_ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 6px;
    color: var(--primary-foreground);
}

.ProviderSelectionForm-cardHeaderInnerFlexWrapper-FeDD_ svg {
    position: relative;
    top: 3px;
    width: 18px;
    height: 18px;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.ProviderSelectionForm-cardHeaderInnerFlexWrapper-FeDD_ .ProviderSelectionForm-cardHeading-d6isZ {
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
    margin: 0;
}

.ProviderSelectionForm-cardDescriptionContainer-hODCU {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 6px;
}

.ProviderSelectionForm-cardDescriptionContainer-hODCU svg {
    position: relative;
    top: 3px;
    width: 12px;
    height: 15px;
}

.ProviderSelectionForm-cardDescription-qllSc {
    font-size: 14px;
    line-height: 24px;
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/ProviderSelectionForm/ProviderSelectionForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,oBAAoB;IACpB,8CAA8C;IAC9C,mBAAmB;IACnB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;IACR,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb","sourcesContent":[".providerSectionCardWrapper {\n    display: grid;\n    gap: 18px;\n}\n\n.providerSectionCard {\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    padding: 18px;\n    cursor: pointer;\n}\n\n.cardHeaderContainer {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid var(--primary-border);\n    margin-bottom: 12px;\n    align-items: center;\n}\n\n.cardHeaderInnerFlexWrapper {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 6px;\n    color: var(--primary-foreground);\n}\n\n.cardHeaderInnerFlexWrapper svg {\n    position: relative;\n    top: 3px;\n    width: 18px;\n    height: 18px;\n    flex-shrink: 0;\n}\n\n.cardHeaderInnerFlexWrapper .cardHeading {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.cardDescriptionContainer {\n    display: flex;\n    align-items: flex-start;\n    gap: 6px;\n}\n\n.cardDescriptionContainer svg {\n    position: relative;\n    top: 3px;\n    width: 12px;\n    height: 15px;\n}\n\n.cardDescription {\n    font-size: 14px;\n    line-height: 24px;\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"providerSectionCardWrapper": `ProviderSelectionForm-providerSectionCardWrapper-HHOCp`,
	"providerSectionCard": `ProviderSelectionForm-providerSectionCard-nXB1G`,
	"cardHeaderContainer": `ProviderSelectionForm-cardHeaderContainer-PU09N`,
	"cardHeaderInnerFlexWrapper": `ProviderSelectionForm-cardHeaderInnerFlexWrapper-FeDD_`,
	"cardHeading": `ProviderSelectionForm-cardHeading-d6isZ`,
	"cardDescriptionContainer": `ProviderSelectionForm-cardDescriptionContainer-hODCU`,
	"cardDescription": `ProviderSelectionForm-cardDescription-qllSc`
};
module.exports = ___CSS_LOADER_EXPORT___;
